import { Component, input } from '@angular/core';
import { CartItemViewModel, AmountPipe } from '@shared';

@Component({
  selector: 'ntt-cart-item-row',
  imports: [AmountPipe],
  templateUrl: './cart-item-row.html',
  styleUrl: './cart-item-row.scss',
})
export class CartItemRow {
  readonly item = input.required<CartItemViewModel>();
}
